import { OrderSubState } from '../lims-types';

// Map OrderSubState to i18n keys under lims:orderSubStateStepper.subStates.*
export const ORDER_SUBSTATE_I18N_KEYS = {
  [OrderSubState.OrderCreated]: 'orderSubStateStepper.subStates.orderCreated',
  [OrderSubState.LabProcess]: 'orderSubStateStepper.subStates.labProcess',
  [OrderSubState.Report]: 'orderSubStateStepper.subStates.report',
  [OrderSubState.FollowUpTasks]: 'orderSubStateStepper.subStates.followUpTasks',
  [OrderSubState.Completed]: 'orderSubStateStepper.subStates.completed',
} as const;

// Extract the union of all i18n key values
export type OrderSubstateI18nKey =
  (typeof ORDER_SUBSTATE_I18N_KEYS)[keyof typeof ORDER_SUBSTATE_I18N_KEYS];

// Map ServiceRequest.status to i18n keys under lims:orderList.statuses.*
export const ORDER_STATUS_I18N_KEYS = {
  draft: 'orderList.statuses.draft',
  active: 'orderList.statuses.active',
  completed: 'orderList.statuses.completed',
  'entered-in-error': 'orderList.statuses.enteredInError',
  'on-hold': 'orderList.statuses.onHold',
  revoked: 'orderList.statuses.revoked',
  unknown: 'orderList.statuses.unknown',
} as const;

// Extract the union of all i18n key values
export type OrderStatusI18nKey =
  (typeof ORDER_STATUS_I18N_KEYS)[keyof typeof ORDER_STATUS_I18N_KEYS];

export interface KanbanColumn {
  id: OrderSubState;
  color: string;
}

export const KANBAN_COLUMNS: KanbanColumn[] = [
  { id: OrderSubState.OrderCreated, color: 'green' },
  { id: OrderSubState.LabProcess, color: 'indigo' },
  { id: OrderSubState.Report, color: 'violet' },
  { id: OrderSubState.FollowUpTasks, color: 'orange' },
  { id: OrderSubState.Completed, color: 'green' },
];
